// src/components/health/SurveyModal.jsx
import { Fragment, useEffect } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";

export default function SurveyModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    children,
    confirmText = "저장",
    cancelText = "취소",
    message,
    danger = false,
    confirmDisabled = false,
}) {
    useEffect(() => {
        if (!isOpen) return;
        const onKeyDown = (e) => {
            if (e.key === "Escape") onClose?.();
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;
    const stop = (e) => e.stopPropagation();

    const confirmColor =
        danger
            ? "bg-red-500 hover:bg-red-600 focus-visible:ring-red-500"
            : "bg-[#5F9BFF] hover:brightness-95 focus-visible:ring-[#5F9BFF]";

    return (
        <Fragment>
            <div
                className="fixed inset-0 bg-black/30 z-40"
                onClick={onClose}
                aria-hidden="true"
            />

            <div
                role="dialog"
                aria-modal="true"
                className="fixed inset-0 z-50 flex items-center justify-center p-4"
                onClick={onClose}
            >
                <section
                    className="
                    relative w-[92vw] max-w-[720px] md:max-w-[550px]
                    rounded-lg bg-white shadow-xl
                    pt-3 pb-5 px-5 md:pb-6 md:pt-4 max-h-[85vh] overflow-y-auto
                "
                    onClick={stop}
                >
                    {/* Header */}
                    <div className="relative flex items-center justify-center mb-4">
                        <div className="absolute left-1/2 -translate-x-1/2 text-xl md:text-2xl font-bold">
                            {title}
                        </div>
                        <button
                            type="button"
                            onClick={onClose}
                            aria-label="닫기"
                            className="ml-auto p-1 rounded-md active:scale-95"
                        >
                            <XMarkIcon className="w-7 h-7 text-gray-500" />
                        </button>
                    </div>

                    {/* Message & Body */}
                    {message && (
                        <div className="mb-2 text-center text-base md:text-lg">{message}</div>
                    )}
                    <div className="text-gray-600 mb-6 text-center text-base md:text-lg">
                        {children}
                    </div>

                    {/* Footer */}
                    <div className="grid grid-cols-2 gap-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="
                                rounded-lg bg-gray-100 px-4 py-2.5
                                text-gray-700 font-semibold
                                text-base md:text-lg
                                hover:bg-gray-200 active:scale-[.99]
                                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#5F9BFF]
                            "
                        >
                            {cancelText}
                        </button>

                        <button
                            type="button"
                            onClick={onConfirm}
                            disabled={confirmDisabled}
                            className={`
                                rounded-lg px-4 py-2.5 text-white font-semibold
                                ${confirmColor} active:scale-[.99] text-base md:text-lg
                                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
                                disabled:opacity-50
                            `}
                        >
                            {confirmText}
                        </button>
                    </div>
                </section>
            </div>
        </Fragment>
    );
}
